import { UserV1 } from '@tovala/browser-apis-combinedapi'
import { getEnvVar } from './env'
import { isURL } from './general'
import { setCookie } from './storage'

export function getTotalCreditsCents({ user }: { user: UserV1 }) {
  return user.cashCents + user.discountCents
}

export function getPublicReviewerName(fullName: string) {
  const nameParts = fullName.trim().split(/\s+/).filter(Boolean)
  const firstName = nameParts[0] ?? ''

  if (nameParts.length < 2) {
    return firstName
  }

  const lastInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase()

  return `${firstName} ${lastInitial}`
}

export function validateNameIsNotURL(
  name: string,
  error: string,
): true | string {
  return !isURL(name.trim()) ? true : error
}

export function setIsMealCustomerCookie(userID: number) {
  const expires = new Date()
  expires.setTime(expires.getTime() + 90 * 24 * 60 * 60 * 1000) // 90 days

  const cookiePathAndDomain = {
    domain:
      // develop-preview is a APP_ENV tied to the my.dev.tovala.com domain and production is my.tovala.com.
      // On other envs (like Vercel preview envs), we don't know what the exact domain will be so we don't
      // explicitly set it.
      getEnvVar('APP_ENV') === 'develop-preview' ||
      getEnvVar('APP_ENV') === 'production'
        ? 'tovala.com'
        : undefined,
    path: '/',
  }

  setCookie({
    content: `${userID}`,
    cookieName: 'MEAL_CUSTOMER',
    options: {
      ...cookiePathAndDomain,
      expires,
      sameSite: 'lax',
    },
  })
}
